<template>
  <a
    class="UserAvatarLink"
    :href="href"
    @click.prevent
  >
    <UserPopover
      :user-id="userId"
      :overlay-centers="overlayCenters"
    >
      <UserAvatar
        :class="avatarClass"
        :compact="compact"
        :user-id="userId"
      />
    </UserPopover>
  </a>
</template>

<script>
import UserAvatar from 'src/components/user_avatar/user_avatar.vue'
import UserPopover from 'src/components/user_popover/user_popover.vue'

import { useUsersStore } from 'src/stores/users.js'

import { profileLink } from 'src/services/user_display/user_display.js'

// A person's avatar that opens their card, and links to their profile for
// middle-click and "copy link" (a plain click opens the card).
export default {
  name: 'UserAvatarLink',
  components: { UserAvatar, UserPopover },
  props: {
    userId: { type: String, required: true },
    compact: Boolean,
    overlayCenters: { type: Boolean, default: true },
    avatarClass: { type: [String, Array, Object], default: null },
  },
  computed: {
    href() {
      const user = useUsersStore().findUser(this.userId)
      return user && this.$router.resolve(profileLink(user)).href
    },
  },
}
</script>
